import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const StudentFormService = {
  // Define your API functions here
  create: async (data) => {
    const response = await apiService.post("/studentinterestforms", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(
        `/studentinterestforms/${id}`,
        updatedData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async ({
    searchText = "",
    status,
    page = 1,
    pageSize = 10,
    enumForm = "",
    fromDate = "",
    toDate = "",
  }) => {
    const params = new URLSearchParams({
      ...(searchText && { searchText }),
      ...(status && { status }),
      ...(enumForm && { enumForm }),
      ...(fromDate && { fromDate }),
      ...(toDate && { toDate }),

      page: page.toString(),
      pageSize: pageSize.toString(),
    });

    const response = await apiService.get(
      `/studentinterestforms?${params.toString()}`
    );
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/studentinterestforms/${id}`);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiService.delete(`/studentinterestforms/${id}`);
    return response.data;
  },
  updateStatus: async (id, data) => {
    const response = await apiService.put(
      `/studentinterestforms/${id}/updated-status`,
      data
    );
    return response.data;
  },
  clearData: async () => {
    const response = await apiService.delete(`/studentinterestforms/clear-all`);
    return response.data;
  },
};

export default StudentFormService;
